import { useEffect, useState } from "react";
import { Navbar, Container, Image } from "react-bootstrap";

import "./_Styles/HeaderTopPublic.css"

export function HeaderTopPublic({ onClickScrollToSection }) {

  const [expanded, setExpanded] = useState(false);

  /* Cerrar offcanvas cuando pasa a desktop */
  useEffect(() => {

    const media = window.matchMedia("(min-width: 992px)");

    const listener = (e) => {
      if (e.matches) setExpanded(false);
    };

    media.addEventListener("change", listener);

    if (media.matches) setExpanded(false);

    return () => media.removeEventListener("change", listener);

  }, []);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="LS__app_header_top_container">

      <Navbar expand="lg" expanded={expanded} onToggle={() => setExpanded(prev => !prev)}
        className={`app_navbar ${scrolled ? "app_navbar_scrolled" : ""}`}
        fixed="top" >

        <Container fluid>
          <Navbar.Brand>
            <Image src={"https://res.cloudinary.com/du8mzxbie/image/upload/v1772082769/Loopy_Studios_-_Logo_zylkht.png"} width={80} onClick={() => onClickScrollToSection("home")} style={{ cursor: "pointer" }} />
          </Navbar.Brand>
        </Container>
      </Navbar>

    </div>
  );
}